import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=78da496f&scoped=true&"
import script from "./Tasks.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da496f",
  null
  
)

export default component.exports